import { POReceivingCreatePage } from "@/features/po-receiving/pages/POReceivingCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admin/receiving/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["po_receiving.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: POReceivingCreatePage,
  validateSearch: z.object({
    purchaseOrderID: z.string().optional(),
  }),
});
